import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { format, addDays } from "date-fns";
import { UserContext } from '../../context/UserContext';
import { ClockLoader } from 'react-spinners';

const getNext30Days = () => {
    const days = [];
    for (let i = 0; i < 30; i++) {
      const date = addDays(new Date(), i);
      days.push(date);
    }
    return days;
};

function TimetableScreen() {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const days = getNext30Days();
  const [cookies] = useCookies();
  const [loadingClasses, setLoadingClasses] = useState(false);
  const [enrolledClasses, setEnrolledClasses] = useState([]);
  const { setTostMessage } = useContext(TostMessageContext);
  const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);

  const handleDateSelect = (date) => {
    console.log("Selected:", date); // YYYY-MM-DD
  };

  const handleClick = (date) => {
    const formatted = format(date, "yyyy-MM-dd");
    setSelectedDate(formatted);
  };

  useEffect(() => {
    getClasses();
  }, [selectedDate])

  const getClasses = async () => {
    setLoadingClasses(true);

    const formData = new FormData();
    formData.append('date', selectedDate);
    try {
        const response = await axios.post(base_url + '/classes/fetch_time_table.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            setLoadingClasses(false);
            if (response.data.results?.length > 0) {
                setEnrolledClasses(response.data.results);
            } else {
              setEnrolledClasses([]);
            }
        } else {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setLoadingClasses(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  const languages = [
    { name: "English", level: 1, color: "bg-blue-200", border: "bg-blue-600" },
    { name: "Yoruba", level: 2, color: "bg-purple-200", border: "bg-purple-600" },
    { name: "Hausa", level: 3, color: "bg-orange-200", border: "bg-orange-600" },
    { name: "Igbo", level: 4, color: "bg-blue-100", border: "bg-blue-500" },
    { name: "Swahili", level: 5, color: "bg-yellow-light", border: "bg-yellow" },
    { name: "Amharic", level: 6, color: "bg-pink-200", border: "bg-pink-600" },
    { name: "French", level: 2, color: "bg-orange", border: "bg-orange" },
    { name: "Lingala", level: 2, color: "bg-teal-200", border: "bg-teal-500" },
    { name: "Oromo", level: 2, color: "bg-blue-300", border: "bg-blue-600" },
    { name: "Zulu", level: 2, color: "bg-rose-100", border: "bg-pink-600" },
    { name: "Shona", level: 2, color: "bg-teal-100", border: "bg-teal-600" },
    { name: "Portuguese", level: 2, color: "bg-purple-200", border: "bg-purple-700" },
  ];


  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='w-full flex flex-row justify-between p-0 lg:p-5'>
                  <div className='w-full border p-5 py-10 border-1 rounded-[10px]'>
                    <div className="w-auto flex items-center justify-between mb-4">
                      <BsChevronLeft className="text-gray-500 cursor-pointer" />
                      <div className="flex gap-5 overflow-x-auto scrollbar-hide">
                        {/* {days.map((day, i) => {
                          const date = dates[i];
                          const isSelected = date === selectedDate;
                          return (
                            <div
                              key={day}
                              className={`flex flex-col items-center justify-center px-5 py-3 rounded-xl ${
                                isSelected ? 'bg-yellow text-black font-bold' : ''
                              }`}
                            >
                              <span className="text-sm">{day}</span>
                              <span className="text-lg">{date}</span>
                            </div>
                          );
                        })} */}
                        {days.map((date, index) => {
                          const isSelected = format(date, "yyyy-MM-dd") === selectedDate;
                          return (
                            <div
                              key={index}
                              onClick={() => handleClick(date)}
                              className={`min-w-[60px] flex flex-col items-center justify-center px-3 py-2 rounded-xl cursor-pointer ${
                                isSelected ? "bg-yellow text-black font-bold" : "bg-gray-100 text-gray-700"
                              }`}
                            >
                              <span className="text-sm">{format(date, "EEE")}</span>
                              <span className="text-lg">{format(date, "d")}</span>
                            </div>
                          );
                        })}
                      </div>
                      <BsChevronRight className="text-gray-500 cursor-pointer" />
                    </div>
                    <div className="w-full py-10">
                      {loadingClasses ? (
                            <div className='w-max flex justify-center items-center mx-auto my-auto'>
                                <ClockLoader
                                    color={'#212121'}
                                    loading={loadingClasses}
                                    size={25}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                            </div>
                        ) : (
                        <>
                          {!loadingClasses && enrolledClasses?.length < 1 ? (
                              <div className='mx-auto w-full my-auto flex flex-col items-center justify-center'>
                                  <div className="text-gray-400 text-sm">No classes fixed for this day</div>
                              </div> 
                          ) : (
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                              {enrolledClasses?.map((lang, index) => (
                                <div key={index} className={`relative border-l-[13px] border-l-[#FF006E] border-r-[#FBE3EC] ${lang.level_id == 1 && 'border-l-yellow border-r-yellow-light'} ${lang.level_id == 2 && 'border-l-[#3C76F1] border-r-[#A1CDFF]'} ${lang.level_id == 3 && 'border-l-[#3ED7BB] border-r-[#B6E9E3]'} border-r-[13px] rounded-xl`}>
                                  <div className={`flex justify-between items-center p-4 bg-[#FBE3EC] ${lang.level_id == 1 && 'bg-yellow-light'} ${lang.level_id == 2 && 'bg-[#A1CDFF]'} ${lang.level_id == 3 && 'bg-[#B6E9E3]'} w-full`}>
                                    <div className="flex flex-col">
                                      <span className="font-semibold text-md">{lang.language}</span>
                                      {lang.category == "GROUP" ? <span className="text-sm">{lang.age_group} years</span> : <span className="text-sm">{lang.child_name}</span>}
                                      <span className="text-sm">{lang.category == "GROUP" ? lang.max_no : '1 of 1'} enrolled</span>
                                      <span className="text-sm">Tutor: {lang.tutor}</span>
                                    </div>
                                    <div className="text-sm font-medium">{lang.date}</div>
                                    {/* <div className={`w-3 h-full absolute left-0 top-0 bottom-0 rounded-l-xl ${'bg-yellow'}`}></div> */}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default TimetableScreen;
